import { Dac7Data } from '@olxeu-a2b/ui/typings/dac7';
import { useQuery, UseQueryResult } from 'react-query';
import { useMemo } from 'react';
import { sdkFactory } from '../../../../extras';

export default function useGetDac7Data(enabled = true): UseQueryResult<Dac7Data | undefined> {
  const sdk = useMemo(() => sdkFactory(), []);

  return useQuery<Dac7Data>(
    'getDac7Data',
    () =>
      sdk.getSellerDac7DataV1().catch(error => {
        if (error.status === 404) {
          return null;
        }
        throw error;
      }),
    { enabled },
  );
}
